import { StrokeColor, StrokeWidth } from "shared/classroom/toolbar/core";

const storageKeys = {
    color: 'config.toolbar.color',
    strokeWidth: 'config.toolbar.stroke-width',
};

const storage = localStorage;
const colorCodeRegex = new RegExp(/^#[a-fA-F0-9]{3}$|^#[a-fA-F0-9]{6}$/i);

export const getStoredColor = () => {
    const color = storage.getItem(storageKeys.color) as null | StrokeColor;
    if (color && !isColorValid(color)) {
        deleteStoredColor();
    }

    return color;
};
export const updateStoredColor = (color: StrokeColor) =>
    storage.setItem(storageKeys.color, color);
export const deleteStoredColor = () => storage.removeItem(storageKeys.color);

export const getStoredStrokeWidth = () => {
    const strokeWidthString = storage.getItem(storageKeys.strokeWidth);
    if (strokeWidthString == null) {
        return null;
    } else {
        return Number.parseInt(strokeWidthString) as StrokeWidth;
    }
};
export const updateStoredStrokeWidth = (strokeWidth: StrokeWidth) =>
    storage.setItem(storageKeys.strokeWidth, '' + strokeWidth);
export const deleteStoredStrokeWidth = () => storage.removeItem(storageKeys.color);



const isColorValid = (color: StrokeColor) => isValidHexColor(color);
const isValidHexColor = (color: string) => colorCodeRegex.test(color);
